'use client';

import type { ReactNode } from 'react';

type SettingsFootnoteProps = {
  /** Leading icon, e.g. an info glyph. */
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
};

/**
 * The tinted hint bar that closes a settings pane — the prototype's `.vp-foot`:
 * a top hairline, a subtle fill, an info glyph and one line of tertiary copy that
 * is the same for every selection.
 */
export const SettingsFootnote = ({ icon, children, className }: SettingsFootnoteProps) => (
  <p
    data-lula-ds=""
    className={`typography-body-sm m-0 flex text-xs! leading-4! items-center gap-space-8 border-t border-solid border-border-subtle bg-bg-subtle px-space-16 py-space-8 text-text-tertiary${
      className ? ` ${className}` : ''
    }`}
  >
    {icon && (
      <span className="inline-flex size-4 shrink-0 [&_svg]:size-4 items-center text-icon-tertiary">
        {icon}
      </span>
    )}
    {children}
  </p>
);

export default SettingsFootnote;
